export default "/images/web-button-agenda-cropped.png?4f6bc08657dffcc77aedeaf3c9a73f9a";